import React from 'react';
import { ArrowRight } from '../icons';
import logo from '../svgs/logo2.svg';
import illustration from '../img/shutdown-illustration.png';

// The terminal state of this old order app. Once the deadline in
// helpers/countdown.js has passed, app.js renders this instead of the router, so
// it is the whole page: there is nothing behind it to dismiss it back to, and no
// route left for a hand-typed URL to resolve to.
//
// Sibling of NewUiBanner (nudges) and SiteClosingModal (interrupts, counts down).
// This one is the end of that sequence and says the move already happened.
const NEW_SITE_URL = 'https://www.sweetpixtiles.com/';
const SUPPORT_EMAIL = 'support@sweetpixapp.com';

export default function ShutdownPage() {
  return (
    <div className="shutdown-page">
      <div className="shutdown-page__card">
        <img
          className="shutdown-page__logo"
          src={logo}
          alt="Sweet Pix"
          width="140"
          height="44"
        />

        <img
          className="shutdown-page__art"
          src={illustration}
          alt=""
          width="436"
          height="345"
        />

        <div className="shutdown-page__copy">
          <h1 className="shutdown-page__headline">This site is no longer in use</h1>
          <p className="shutdown-page__sub">
            We’ve fully shut down this experience. Please continue on our new site
            at sweetpixtiles.com Everything you need is there.
          </p>
        </div>

        <a className="shutdown-page__cta" href={NEW_SITE_URL}>
          Go to sweetpixtiles.com
          <ArrowRight />
        </a>

        <div className="shutdown-page__footer">
          <p className="shutdown-page__support">
            Need help? <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>
          </p>
          <p className="shutdown-page__copyright">© SweetPix Photo Tiles</p>
        </div>
      </div>
    </div>
  );
}
